import { trackEvent } from "../../../trackEvent";
const test = ({ target }) => target.closest(".product-info-gtm");

const push = ({ target }) => {
    const btnName = target.textContent.trim();
    trackEvent({
        event: "click_item_info",
        event_type: "click",
        element_text: btnName,
        item_name: document.querySelector("[data-gtm-product='name']")?.textContent.trim() || ""
    });
}

export default {
  name: "product-info-modal",
  test,
  push
};